import { Component, Inject, Input, OnInit } from '@angular/core';
import {
    ConfirmationTimeRecordingModel,
    DateModel,
    TimesheetEntryInterface,
    TimesheetEntryModel,
    TimesheetManualEntryModel,
    TimeModel,
    TimeUtilities,
    UiResponsiveService,
    ValueHelperInstanceToken,
    ValueHelperInterface,
    ValueHelperModel,
} from '@evorait/pace-core';
import { HTML5_FMT } from 'moment';
import { Observable } from 'rxjs';

@Component({
    selector: 'pace-time-sheet-entries',
    templateUrl: './time-sheet-entries.component.html',
    styleUrls: ['./time-sheet-entries.component.scss'],
    standalone: false,
})
export class TimeSheetEntriesComponent implements OnInit {
    @Input()
    public enableStandbyTravel = false;

    @Input()
    public otherTimeSheetEntries: TimesheetEntryInterface[] = [];

    @Input()
    public model: ConfirmationTimeRecordingModel;

    private workTypes: ValueHelperModel[];
    public isMobile$: Observable<boolean>;
    public constructor(
        @Inject(ValueHelperInstanceToken) private readonly valueHelperService: ValueHelperInterface,
        private readonly uiResponsiveService: UiResponsiveService,
    ) {}
    public ngOnInit(): void {
        this.workTypes = [
            ...this.valueHelperService.getTimesheetGapTypeInfo(), // manual timesheet entries work types
            ...this.valueHelperService.getTimeRecordingTaskTypeInfo(), // notification timesheet entries work types
        ];

        this.isMobile$ = this.uiResponsiveService.isMobile$;
    }

    public getDesc(entry: TimesheetEntryInterface): string {
        // Notification related Timesheet Entry Models save the work code on the workCode property, while manual timesheet entries
        // store a task type on the taskType dropdown.
        if (entry instanceof TimesheetEntryModel) {
            return this.workTypes.find((item) => item.code === entry.workCode.value)?.descText ?? '';
        } else if (entry instanceof TimesheetManualEntryModel) {
            return (
                this.workTypes.find((item) => item.code === entry.taskTypeDropdown.selectedEntry?.value)?.descText ?? ''
            );
        }
        return '';
    }

    /**
     * The signal-forms `pace-date-field` / `pace-time-field` carry the native HTML5
     * string (`yyyy-MM-dd` / `HH:mm`), not a `moment`, so the read-only display here
     * needs the same conversion the reactive-forms `DateInputComponent` /
     * `TimeInputComponent` do internally. An invalid moment renders as an empty field.
     */
    public toHtml5Date(model: DateModel): string {
        return model.value.isValid() ? model.value.format(HTML5_FMT.DATE) : '';
    }

    public toHtml5Time(model: TimeModel): string {
        return model.value.isValid() ? model.value.format(HTML5_FMT.TIME) : '';
    }

    public isOverlapping(entry: TimesheetEntryInterface): boolean {
        return this.model.timeRecordingEntries.value.some((timeRecEntry) =>
            TimeUtilities.hasOverlap(
                entry.startTime.value,
                entry.endTime.value,
                timeRecEntry.startDateTime,
                timeRecEntry.endDateTime,
            ),
        );
    }
}
